/** Same rules as IB clients list: truncate long names; use `title` on the element for the full value. */
export function formatIbClientName(name, maxLen = 13, emptyLabel = "NAN") {
  const clean = String(name || "").trim();
  if (!clean) return emptyLabel;
  if (clean.length <= maxLen) return clean;
  return `${clean.slice(0, maxLen)}...`;
}
